//@flow

import * as React from 'react';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import DoneIcon from './../../../../../icons/DoneIcon.svg';
import ErrorIcon from './../../../../../icons/ErrorIcon.svg';
import DeleteIcon from './../../../../../icons/delete.svg';
//import FileForm from './FileForm';
//import type { Attribute } from './../../../../../types/upload';

type Props = {
    setCurrentIndex: (index: number) => {},
    index: number,
    fileAttributes: Array<Object>,
    t: (s: string) => string,
    disabled: boolean
};

const FilesListWrapper = styled.div`                       
  width: 100%;
  overflow: auto;
  flex-shrink: 4;
  display: block
  margin-bottom: 10px;
  flex-grow: 1;
  opacity: ${props => props.disabled ? 0.5 : 1};
`;

const CustomMarginParagraph = styled.p`
  display: ${props => props.visible ? "block" : "none"};
  margin: 5px 0 0 0;
  color: rgb(40, 40, 40);
`;

const StyledFilesList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: flex-end;  
  overflow: auto;
  border: 1px solid #ebebeb;
  background-color: #ffffff;
  border-radius: 5px;
`;

const StyledFileName = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  margin-top: 15px;
  margin-bottom: 5px;
  font-weight: ${props => props.selected ? "bold" : 'normal'};
  border-radius: 2px;
`;

const StyledReactSVG = styled(ReactSVG)`
  path{
    stroke: #000000;
    fill: #000000;  
  }
`;

const StyledFileLabel = styled.div`
    white-space: pre-wrap;
    :hover {
      cursor: pointer;
    }
`;

const StyledIcon = styled.img`
  height: 20px;
  margin-left: ${props => props.marginLeft ? props.marginLeft : 'auto'};
  margin-right: 5px;

  :hover {
    cursor: pointer;
  }
`;

const FileDataWrapper = styled.div`
  width: 100%;
`;

/*const FileAttributes = styled.div`
  max-height: ${props => props.selected ? '200px' : '0'};
  transition: max-height 0.5s;
  transition-timing-function: ease;
  overflow-x: hidden;
  overflow-y: hidden;
`;*/

/*const checkAttributes = (attributes: Array<Attribute>): boolean => {
  return !attributes.some((attribute: Attribute) => attribute.optional === false && attribute.value === '');
};*/

const FilesList = (props: Props): React.Node => {
    const { t, files, onDelete, disabled }: Props = props;
    return (
        <FilesListWrapper disabled={disabled}>
            <CustomMarginParagraph visible={files.length > 0}><b>{t('Files')}</b></CustomMarginParagraph>
            <StyledFilesList>
                {files.map((file, arrayIndex) => (
                    <FileDataWrapper key={arrayIndex} >
                        <StyledFileName /*selected={index === arrayIndex}*/>
                            <StyledIcon marginLeft='5px' src={true ? DoneIcon : ErrorIcon} />
                            <StyledFileLabel onClick={() => {
                                //setCurrentIndex(arrayIndex);
                            }}>
                                {file.name}
                            </StyledFileLabel>
                            <div
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    if (!disabled) {
                                        const filteredFiles = files.filter(selectedFile => {
                                            return file.name !== selectedFile.name
                                        })
                                        onDelete(filteredFiles);
                                    }
                                }}
                            >
                                <StyledReactSVG
                                    path={DeleteIcon}
                                    style={{
                                        width: '15px',
                                        height: '15px',
                                    }}
                                />
                            </div>
                        </StyledFileName>
                        {/*<FileAttributes
              selected={index === arrayIndex}
            >

              <FileForm
                fileAttributes={props.fileAttributes}
                index={arrayIndex}
                attributes={props.attributes}
                onFormChange={props.onFormChange} />

            </FileAttributes>*/}
                    </FileDataWrapper>
                ))}
            </StyledFilesList>
        </FilesListWrapper>
    );
};

export default FilesList;



// WEBPACK FOOTER //
// ./src/containers/content/grid/uploadPanel/filesList/FilesList.jsx